import React from "react";
import { Form } from "react-bootstrap";
import { useAcademicYear } from "./AcademicYearContext";
import { Term } from "common/types";

interface AcademicYearSelectorProps {
  terms: Term[];
}

const AcademicYearSelector: React.FC<AcademicYearSelectorProps> = ({
  terms,
}) => {
  const {
    selectedAcademicYear,
    setSelectedAcademicYear,
    getAcademicYear,
    getCurrentAcademicYear,
  } = useAcademicYear();

  // Get all available academic years from terms
  const getAvailableAcademicYears = (): string[] => {
    const years = new Set<string>();
    terms.forEach((term) => {
      const academicYear = getAcademicYear(new Date(term.start));
      years.add(academicYear);
    });
    return Array.from(years).sort().reverse(); // Most recent first
  };

  const availableYears = getAvailableAcademicYears();

  return (
    <div className="mb-4">
      <Form.Group className="d-flex align-items-center gap-2">
        <Form.Label className="mb-0 fw-bold">Školska godina:</Form.Label>
        <Form.Select
          value={selectedAcademicYear}
          onChange={(e) => setSelectedAcademicYear(e.target.value)}
          style={{ width: "auto" }}
        >
          <option value="current">
            Trenutna školska godina ({getCurrentAcademicYear()})
          </option>
          <option value="all">Sve školske godine</option>
          {availableYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  );
};

export default AcademicYearSelector;
